import { CrmPersona } from "components/ui/persona";
import React from "react";
import { Link } from "react-router-dom";
import { useTenantSettings } from "store/selectors/settings";

interface ClientPersonaLinkProps {
    size?: "small" | "large" | "auto";
    client: {
        appLink: string;
        name?: string;
        bestContactName?: string;
    };
}

export const ClientPersonaLink: React.FC<ClientPersonaLinkProps> = props => {
    const { client, size = "large" } = props;
    const stopPropagation: React.MouseEventHandler<HTMLAnchorElement> = React.useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.stopPropagation();
        },
        [],
    );

    const { settings } = useTenantSettings();
    const showClientFirst = settings.showClientFirst;

    const primaryName = (showClientFirst ? client.name : client.bestContactName) || "";
    const secondaryName = (showClientFirst ? client.bestContactName : client.name) || "";

    return (
        <Link onClick={stopPropagation} to={client.appLink}>
            <div
                className={`flex items-center ${size === "small" ? "space-x-2" : "space-x-4"}`}>
                <div className="flex-shrink-0">
                    <CrmPersona size={size} initialsOnly name={client.name} />
                </div>
                <div>
                    <div className="text-sm font-medium truncate text-gray-900">
                        {primaryName}
                    </div>
                    <div className="text-sm truncate text-gray-500">{secondaryName}</div>
                </div>
            </div>
        </Link>
    );
};
